import { useQuery } from '@apollo/client';
import { GET_USER_LOGIN_DETAILS } from 'graphql/secure/queries';
import { ICompany } from 'FeatureModules/Auth/types/company.types';
import { ICompanyUser } from 'FeatureModules/Auth/types/companyUser.types';

interface IUserDataValues {
  company?: ICompany;
  user?: ICompanyUser;
  refetch: () => void;
}

const useUserData = (): IUserDataValues => {
  const { data: { company, user } = {}, refetch } = useQuery<IUserDataValues>(
    GET_USER_LOGIN_DETAILS,
    {
      fetchPolicy: 'cache-only',
    }
  );

  return {
    company,
    user,
    refetch,
  };
};

export default useUserData;
